import type { Locale } from '@mfw/translations';

import type {
  UiQueCreateExercise,
  UiQueEditExercise,
} from '../../schemas/exercises.schema';

export const UploadWorkerTaskEvent = {
  OnCreateExerciseCompleted: 'OnCreateExerciseCompleted',
  OnEditExerciseCompleted: 'OnEditExerciseCompleted',
  OnError: 'OnError',
  OnProgress: 'OnProgress',
  // Posted once, from the worker's module top: its imports ran, so every
  // `importScripts` succeeded. Releases the worker's stale-chunk reload guard.
  OnReady: 'OnReady',
  OnStopped: 'OnStopped',
  StartCreateUpload: 'StartCreateUpload',
  StartEditUpload: 'StartEditUpload',
  StopUpload: 'StopUpload',
} as const;

export type UploadWorkerTaskEventType = keyof typeof UploadWorkerTaskEvent;

export type UploadWorkerTaskMeta = UiQueCreateExercise | UiQueEditExercise;

export type UploadWorkerTaskStatus = 'done' | 'error' | 'uploading';

export type UploadWorkerTask = {
  status: UploadWorkerTaskStatus;
  meta: UploadWorkerTaskMeta;
  progress: number;
  locale: Locale;
  id: string;
};

export type UploadWorkerQueArgs = Pick<UploadWorkerTask, 'meta'>;

export type UploadWorkerDequeArgs = { id: string };

export type UploadWorkerUpdateProgressArgs = { progress: number; id: string };
